export default {
  SET_TENANT_REQUIRED: 'setTenantRequired',
  SET_FILTERS: 'setFilters',
  SET_SELECTED_FILTER: 'setSelectedFilter',
  SET_FIELD_TENANTS: 'setFieldTenants',
  SET_FIELDS_LIST: 'setFieldsList',
  SET_GROUPS_LIST: 'setGroupsList',
}
